const reportStatus = {
	name: 'Report Status',
	fields: {},
	processStep: 'Process step',
	orderHint:
		'The order matches the columns in the Kanban under "Open requests" and its status selection. Drag a status by its handle to move it.',
	kanbanHint:
		'Drag columns by their header or use the arrows in the status menu to reorder them. The default order is set under Settings > Definitions > Report status.',
	restoreDefault: 'Restore default',
	dragHandle: 'Drag to reorder',
	moveUp: 'Move up',
	moveDown: 'Move down',
	editInAdmin: 'Manage report status in settings',
	position: 'Position {n}',
	process: {
		open: 'Open',
		processing: 'In Progress',
		denied: 'Denied',
		done: 'Completed',
	},
}

export default reportStatus
